import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  href,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center bg-terra text-white font-bold py-4 px-8 rounded-full shadow-lg hover:bg-[#A86A3F] hover:scale-[1.02] transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-terra/30 active:scale-95';
  if (href) {
    return <a href={href} className={`${baseStyles} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-190">
        {children}
      </a>;
  }
  return <button className={`${baseStyles} ${className}`} {...props} data-id="element-191">
      {children}
    </button>;
}